/**
 * 缓存工具
 * @author dzq
 */
import store from "../store";

const getKey = (key, isUser) => {
  if (!isUser) {
    return `mgcard-superlive-${key}`;
  }

  const { userInfo } = store.state;
  return `mgcard-superlive-${userInfo.uuid}-${key}`;
};

/**
 * 设置缓存
 * @param {string} key
 * @param {object} value
 */
export const setStorage = (key, value, isUser) => {
  try {
    localStorage.setItem(getKey(key, isUser), JSON.stringify(value));
  } catch (e) {
    console.error("设置缓存失败:", e);
  }
};

/**
 * 获取缓存
 * @param {string} key
 * @returns
 */
export const getStorage = (key, isUser) => {
  let value;
  try {
    value = localStorage.getItem(getKey(key, isUser));

    if (value) {
      value = JSON.parse(value);
    }
  } catch (e) {
    console.log("获取缓存失败:", e);
  }
  return value;
};

/**
 * 清除缓存
 * @param {String} key
 */
export const clearStorage = (key, isUser) => {
  try {
    localStorage.removeItem(getKey(key, isUser));
  } catch (e) {
    console.error("清除缓存失败:", e);
  }
};

/**
 * 设置用户缓存
 * @param {string} key
 * @param {object} value
 */
export const setUserStorage = (key, value) => {
  setStorage(key, value, true);
};

/**
 * 获取用户缓存
 * @param {string} key
 * @returns
 */
export const getUserStorage = (key) => {
  return getStorage(key, true);
};

/**
 * 清除用户缓存
 * @param {String} key
 */
export const clearUserStorage = (key) => {
  clearStorage(key, true);
};

/**
 * 设置有效期缓存
 * @param {String} key
 * @param {Object} value
 */
export const setDurationStorage = (key, value) => {
  setStorage(key, {
    time: new Date().getTime(),
    value,
  });
};

/**
 * 获取有效期缓存
 * @param {String} key
 * @param {Number} duration 有效期时长（时）
 */
export const getDurationStorage = (key, duration = 24) => {
  const storage = getStorage(key);

  if (storage) {
    if ((new Date().getTime() - storage.time) / 1000 / 60 / 60 > duration) {
      clearStorage(key);

      return null;
    }

    return storage.value;
  }

  return null;
};
